import clsx from 'clsx'
import React from 'react'

import {css} from '../../theme/css'
import {theme} from '../../theme/theme'

const className = css`
  border: 0 none;
  height: 1px;
  background: rgba(195, 194, 190, 0.4);
  margin: ${theme.spacing(2, 0)};

  ${theme.breakpoints.down('sm')} {
    margin: ${theme.spacing(2, -1.5)};
  }
`

const Divider: React.FC<React.PropsWithChildren<JSX.IntrinsicElements['hr']>> = ({
  className: classNameProp,
  ...props
}) => {
  return <hr {...props} className={clsx(className, classNameProp)} />
}

export default Divider
